import $ from "jquery";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import React from "react";

import Icon from "./nounproject-ui-icon";
import EduPricing from "../components/nounproject-edu-pricing";

class NounProjectPluginSignup extends React.Component {
    attemptSubmitForm(e) {
        e.preventDefault();

        let password = this.passwordInput.value,
            email = this.emailInput.value;

        this.setState({
            processing: true,
            fieldErrors: {}
        });

        let formData = $(".signup-form").serialize();

        formData = `${formData}&signup_type=basic`;
        this.props.signup(formData);
    }

    clearErrors() {
        this.setState({
            processing: false,
            error: false,
            fieldErrors: {}
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.error) {
            this.setState({
                processing: false,
                error: true,
                fieldErrors: nextProps.error
            });
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            processing: false,
            error: null,
            fieldErrors: {},
            priceInDollars: "19",
            priceInCents: "99"
        };
    }

    showLogin(e) {
        e.preventDefault();
        browserHistory.push("/for-edu/login");
    }

    render() {
        let submitButtonClasses = [
                "button",
                "blue",
                "full-width",
                "ui_sign-up",
                "button-process"
            ],
            inputDisabled;

        if (this.state.processing) {
            submitButtonClasses.push("processing");
            inputDisabled = "disabled";
        }

        let fld,
            errors = this.state.fieldErrors,
            err,
            fields = {
                email: {
                    className: "",
                    labelClassName: "show",
                    placeholderText: "Email",
                    labelText: "Email"
                },
                password1: {
                    className: "",
                    labelClassName: "show",
                    placeholderText: "Password",
                    labelText: "Password"
                },
                accept_terms: {
                    className: "",
                    labelClassName: "must-agree",
                    labelText: ""
                }
            };

        for (fld in errors) {
            err = errors[fld];
            fields[fld].className += " error on";
            fields[fld].labelClassName += " error on";
            fields[fld].labelText = err;
        }

        return (
            <div className="container">
                <span
                    className="row"
                    style={{
                        color: "white",
                        minHeight: "100%"
                    }}
                >
                    <style>{`
                        #for-edu{
                            background: #000000;
                            color: #FFFFFF;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            background-color: $black;
                            min-height: 500px;
                        }
                        #for-edu::before{
                            content: ' ';
                            position: fixed;
                            top: 0;
                            left: 0;
                            background: #1a1a1a;
                            height: 100%;
                            width: 50%;
                        }
                        .billing-list-of-apps .app-list-app{
                            font-size: 12px;
                            justify-content: flex-start;
                            align-items: center;
                            padding: 4px 8px;
                        }
                        .billing-list-of-apps .app-list-app img{
                            margin-right: 8px;
                        }
                    `}</style>
                    <div className="signupView col-lg-5 col-md-5 col-sm-5 col-xs-12">
                        <style>{`
                        .signupView .text-link,
                        .signupView .text-link:hover {
                            color: white
                        }
                    `}</style>
                        <form
                            action={`/accounts/signup/pro/?next=/plugin/${
                                this.props.host
                            }#/search`}
                            method="POST"
                            className="margin-t-xxl new-form dark-form signup-form plugin-form"
                            onSubmit={this.attemptSubmitForm.bind(this)}
                        >
                            <h1 className="weight-medium margin-b-l">
                                Sign up
                            </h1>
                            <ol>
                                <li className="padding-b-s">
                                    <input
                                        id="user_id"
                                        className="input"
                                        maxLength="254"
                                        name="email"
                                        type="text"
                                        required=""
                                        placeholder="Email Address"
                                        autoFocus="autofocus"
                                        ref={input => {
                                            this.emailInput = input;
                                        }}
                                        disabled={inputDisabled}
                                    />
                                    <label
                                        htmlFor="id_email"
                                        className={fields.email.labelClassName}
                                    >
                                        {fields.email.labelText}
                                    </label>
                                    <label
                                        htmlFor="user_id"
                                        className="ui_icon ui_email"
                                    />
                                </li>
                                <li className="padding-b-s">
                                    <input
                                        id="id_password"
                                        maxLength="4096"
                                        name="password1"
                                        type="password"
                                        placeholder="Password"
                                        className="input"
                                        required=""
                                        ref={input => {
                                            this.passwordInput = input;
                                        }}
                                        disabled={inputDisabled}
                                    />
                                    <label
                                        htmlFor="id_password1"
                                        className={
                                            fields.password1.labelClassName
                                        }
                                    >
                                        {fields.password1.labelText}
                                    </label>
                                    <label
                                        htmlFor="id_password"
                                        className="ui_icon ui_lock"
                                    />
                                </li>
                                <li className="margin-t-xl margin-l-m">
                                    <label
                                        htmlFor="receive_updates"
                                        className="display-flex flex-align-center flex-justify-start"
                                    >
                                        <input
                                            id="receive_updates"
                                            name="receive_updates"
                                            className="checkbox-input"
                                            type="checkbox"
                                            defaultChecked="true"
                                        />
                                        <label
                                            htmlFor="receive_updates"
                                            className="checkbox-fillin"
                                        >
                                            <i className="ui_check-mark" />
                                        </label>
                                        <span>
                                            Send me occasional emails about the
                                            Noun&nbsp;Project community.
                                        </span>
                                    </label>
                                </li>

                                <li className="margin-l-m">
                                    <label
                                        htmlFor="accept_terms"
                                        className="display-flex flex-align-center flex-justify-start"
                                    >
                                        <input
                                            id="accept_terms"
                                            className="checkbox-input"
                                            name="accept_terms"
                                            type="checkbox"
                                        />
                                        <label
                                            htmlFor="accept_terms"
                                            className="checkbox-fillin"
                                        >
                                            <i className="ui_check-mark" />
                                        </label>
                                        <span>
                                            I agree to the{" "}
                                            <a
                                                href="/legal/#!terms-of-use/"
                                                className="text-link color-white"
                                            >
                                                Terms of Use
                                            </a>.
                                        </span>
                                    </label>
                                    <label
                                        htmlFor="accept_terms"
                                        className="signup-errors"
                                    >
                                        {fields.accept_terms.labelText}
                                    </label>
                                </li>
                            </ol>
                            <ol className="sign-up-buttons margin-t-m">
                                <li>
                                    <button
                                        className={submitButtonClasses.join(
                                            " "
                                        )}
                                        type="submit"
                                    >
                                        <span>Create my account</span>
                                    </button>
                                </li>
                            </ol>
                            <ol
                                className="margin-t-xxl"
                                style={{ textAlign: "center" }}
                            >
                                <li className="margin-b-l">
                                    <a
                                        className="already-have-account text-link"
                                        href="/for-edu/login/"
                                        onClick={this.showLogin.bind(this)}
                                    >
                                        <span>I have an account</span>
                                    </a>
                                </li>
                            </ol>
                        </form>
                    </div>
                    <div className="col-lg-5 col-md-5 col-sm-5 col-sm-offset-2 col-sm-12">
                        <EduPricing />
                    </div>
                </span>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let host = state.plugin.host;

    return { host };
}

module.exports = connect(mapStateToProps, {})(NounProjectPluginSignup);
